export default __webpack_public_path__ + "static/media/thumbnail.8abf0d45.svg";